import { render, staticRenderFns } from "./board_tg.vue?vue&type=template&id=4e1d3626&scoped=true"
import script from "./board_tg.vue?vue&type=script&lang=js"
export * from "./board_tg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d3626",
  null
  
)

export default component.exports